import axios from '@_system/axios/axios.js'
export default {
	path: '/company',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	getById(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/getById/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	getseal(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getseal/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	getemun(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getemun', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	

	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/company', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
}
